/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getLLMProject = /* GraphQL */ `query GetLLMProject($id: ID!) {
  getLLMProject(id: $id) {
    id
    name
    status
    description
    users {
      items {
        id
        email
        status
        displayName
        acceptedTermsOfService
        acceptedGDPRTerms
        projectId
        project {
          id
          name
          status
          description
          stripeCustomerId
          newCustomerTokenCount
          cacheResponsesForSeconds
          loadSheddingTier
          newCustomerLoadSheddingTier
          maintenanceMode
          maintenanceModeMessage
          loadBalancingMode
          piiRedactionScope
          systemInstructions
          piiScope
          piiGroupId
          piiMessage
          promptBlacklist
          blacklistGroupId
          blacklistMessage
          safety
          safetyGroupId
          safetyMessage
          strongModelGroupId
          routeModel
          trialTokensRemaining
          logfileRetentionPeriod
          callRetentionPeriod
          logInterval
          lastLogGeneratedAt
          logGenerationCursor
          enterpriseAllowChat
          enterpriseAcceptableUsePolicy
          enterpriseAccessRequestEmail
          enterpriseSupportEmail
          enterpriseDomainWhitelist
          enterpriseTokenBudget
          enterpriseTokenBudgetPeriod
          enterpriseImageUrl
          randomGroup
          apiCreditRemaining
          createdAt
          summaryEmailPeriod
          summaryEmailAddresses
          lastSummaryEmailSentAt
          mcpServerWhitelist
          automaticModelManagement
          supersmallGroupModels
          standardGroupModels
          premiumGroupModels
          reasoningGroupModels
          superpremiumGroupModels
          openrouterStandardGroupModels
          openrouterPremiumGroupModels
          azureOpenaiBaseUrl
          azureOpenaiApiVersion
          awsBedrockRegion
          newCustomerUsageTierId
          usageTapUsageApiKey
          lowApiCreditNotificationEmails
          lowApiCreditNotificationMinimumCredit
          lastLowApiCreditNotificationSentAt
          integrationApiKey1Hash
          integrationApiKey1Status
          integrationApiKey1Prefix
          integrationApiKey1LastRotatedAt
          integrationApiKey1Scopes
          integrationApiKey2Hash
          integrationApiKey2Status
          integrationApiKey2Prefix
          integrationApiKey2LastRotatedAt
          integrationApiKey2Scopes
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    services {
      items {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    stripeCustomerId
    subscription {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    newCustomerTokenCount
    cacheResponsesForSeconds
    loadSheddingTier
    newCustomerLoadSheddingTier
    maintenanceMode
    maintenanceModeMessage
    loadBalancingMode
    piiRedactionScope
    systemInstructions
    piiScope
    piiGroupId
    piiMessage
    promptBlacklist
    blacklistGroupId
    blacklistMessage
    safety
    safetyGroupId
    safetyMessage
    strongModelGroupId
    routeModel
    trialTokensRemaining
    logfileRetentionPeriod
    callRetentionPeriod
    logInterval
    lastLogGeneratedAt
    logGenerationCursor
    enterpriseAllowChat
    enterpriseAcceptableUsePolicy
    enterpriseAccessRequestEmail
    enterpriseSupportEmail
    enterpriseDomainWhitelist
    enterpriseTokenBudget
    enterpriseTokenBudgetPeriod
    enterpriseImageUrl
    randomGroup
    apiCreditRemaining
    createdAt
    summaryEmailPeriod
    summaryEmailAddresses
    lastSummaryEmailSentAt
    mcpServerWhitelist
    automaticModelManagement
    supersmallGroupModels
    standardGroupModels
    premiumGroupModels
    reasoningGroupModels
    superpremiumGroupModels
    openrouterStandardGroupModels
    openrouterPremiumGroupModels
    azureOpenaiBaseUrl
    azureOpenaiApiVersion
    awsBedrockRegion
    newCustomerUsageTierId
    newCustomerUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    usageTapUsageApiKey
    lowApiCreditNotificationEmails
    lowApiCreditNotificationMinimumCredit
    lastLowApiCreditNotificationSentAt
    integrationApiKey1Hash
    integrationApiKey1Status
    integrationApiKey1Prefix
    integrationApiKey1LastRotatedAt
    integrationApiKey1Scopes
    integrationApiKey2Hash
    integrationApiKey2Status
    integrationApiKey2Prefix
    integrationApiKey2LastRotatedAt
    integrationApiKey2Scopes
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMProjectQueryVariables,
  APITypes.GetLLMProjectQuery
>;
export const listLLMProjects = /* GraphQL */ `query ListLLMProjects(
  $filter: ModelLLMProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMProjectsQueryVariables,
  APITypes.ListLLMProjectsQuery
>;
export const projectsByLogIntervalAndLastLogGeneratedAt = /* GraphQL */ `query ProjectsByLogIntervalAndLastLogGeneratedAt(
  $logInterval: String!
  $lastLogGeneratedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByLogIntervalAndLastLogGeneratedAt(
    logInterval: $logInterval
    lastLogGeneratedAt: $lastLogGeneratedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByLogIntervalAndLastLogGeneratedAtQueryVariables,
  APITypes.ProjectsByLogIntervalAndLastLogGeneratedAtQuery
>;
export const projectsByRandomGroupAndCreatedAt = /* GraphQL */ `query ProjectsByRandomGroupAndCreatedAt(
  $randomGroup: Int!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByRandomGroupAndCreatedAt(
    randomGroup: $randomGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByRandomGroupAndCreatedAtQueryVariables,
  APITypes.ProjectsByRandomGroupAndCreatedAtQuery
>;
export const projectsByRandomGroupAndSummaryEmailPeriod = /* GraphQL */ `query ProjectsByRandomGroupAndSummaryEmailPeriod(
  $randomGroup: Int!
  $summaryEmailPeriod: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByRandomGroupAndSummaryEmailPeriod(
    randomGroup: $randomGroup
    summaryEmailPeriod: $summaryEmailPeriod
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByRandomGroupAndSummaryEmailPeriodQueryVariables,
  APITypes.ProjectsByRandomGroupAndSummaryEmailPeriodQuery
>;
export const projectsByIntegrationApiKey1Hash = /* GraphQL */ `query ProjectsByIntegrationApiKey1Hash(
  $integrationApiKey1Hash: String!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByIntegrationApiKey1Hash(
    integrationApiKey1Hash: $integrationApiKey1Hash
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByIntegrationApiKey1HashQueryVariables,
  APITypes.ProjectsByIntegrationApiKey1HashQuery
>;
export const projectsByIntegrationApiKey2Hash = /* GraphQL */ `query ProjectsByIntegrationApiKey2Hash(
  $integrationApiKey2Hash: String!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMProjectFilterInput
  $limit: Int
  $nextToken: String
) {
  projectsByIntegrationApiKey2Hash(
    integrationApiKey2Hash: $integrationApiKey2Hash
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProjectsByIntegrationApiKey2HashQueryVariables,
  APITypes.ProjectsByIntegrationApiKey2HashQuery
>;
export const getLLMUsageTier = /* GraphQL */ `query GetLLMUsageTier($id: ID!) {
  getLLMUsageTier(id: $id) {
    id
    projectId
    status
    name
    description
    version
    activeAt
    inactiveAt
    priorUsageTierId
    priorUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    baseUsageTierId
    baseUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    replenishmentPeriod
    replenishmentMethod
    usageLimitAction
    standardTokenReplenishmentAmount
    premiumTokenReplenishmentAmount
    superPremiumTokenReplenishmentAmount
    reasoningTokenReplenishmentAmount
    standardCallReplenishmentAmount
    premiumCallReplenishmentAmount
    superPremiumCallReplenishmentAmount
    reasoningCallReplenishmentAmount
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMUsageTierQueryVariables,
  APITypes.GetLLMUsageTierQuery
>;
export const listLLMUsageTiers = /* GraphQL */ `query ListLLMUsageTiers(
  $filter: ModelLLMUsageTierFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMUsageTiers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMUsageTiersQueryVariables,
  APITypes.ListLLMUsageTiersQuery
>;
export const usageTiersByProjectId = /* GraphQL */ `query UsageTiersByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMUsageTierFilterInput
  $limit: Int
  $nextToken: String
) {
  usageTiersByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsageTiersByProjectIdQueryVariables,
  APITypes.UsageTiersByProjectIdQuery
>;
export const usageTiersByBaseUsageTierIdAndVersion = /* GraphQL */ `query UsageTiersByBaseUsageTierIdAndVersion(
  $baseUsageTierId: ID!
  $version: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMUsageTierFilterInput
  $limit: Int
  $nextToken: String
) {
  usageTiersByBaseUsageTierIdAndVersion(
    baseUsageTierId: $baseUsageTierId
    version: $version
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsageTiersByBaseUsageTierIdAndVersionQueryVariables,
  APITypes.UsageTiersByBaseUsageTierIdAndVersionQuery
>;
export const getLLMProjectSubscription = /* GraphQL */ `query GetLLMProjectSubscription($id: ID!) {
  getLLMProjectSubscription(id: $id) {
    id
    projectId
    quantity
    subscriptionId
    subscriptionStartDate
    subscriptionEndDate
    subscriptionStatus
    subscriptionProduct
    subscriptionInterval
    subscriptionEndedAt
    subscriptionCancelAtPeriodEnd
    usageSubscriptionId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMProjectSubscriptionQueryVariables,
  APITypes.GetLLMProjectSubscriptionQuery
>;
export const listLLMProjectSubscriptions = /* GraphQL */ `query ListLLMProjectSubscriptions(
  $filter: ModelLLMProjectSubscriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMProjectSubscriptions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      quantity
      subscriptionId
      subscriptionStartDate
      subscriptionEndDate
      subscriptionStatus
      subscriptionProduct
      subscriptionInterval
      subscriptionEndedAt
      subscriptionCancelAtPeriodEnd
      usageSubscriptionId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMProjectSubscriptionsQueryVariables,
  APITypes.ListLLMProjectSubscriptionsQuery
>;
export const getLLMUser = /* GraphQL */ `query GetLLMUser($id: ID!) {
  getLLMUser(id: $id) {
    id
    email
    status
    displayName
    acceptedTermsOfService
    acceptedGDPRTerms
    projectId
    project {
      id
      name
      status
      description
      users {
        items {
          id
          email
          status
          displayName
          acceptedTermsOfService
          acceptedGDPRTerms
          projectId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      services {
        items {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      stripeCustomerId
      subscription {
        id
        projectId
        quantity
        subscriptionId
        subscriptionStartDate
        subscriptionEndDate
        subscriptionStatus
        subscriptionProduct
        subscriptionInterval
        subscriptionEndedAt
        subscriptionCancelAtPeriodEnd
        usageSubscriptionId
        createdAt
        updatedAt
        __typename
      }
      newCustomerTokenCount
      cacheResponsesForSeconds
      loadSheddingTier
      newCustomerLoadSheddingTier
      maintenanceMode
      maintenanceModeMessage
      loadBalancingMode
      piiRedactionScope
      systemInstructions
      piiScope
      piiGroupId
      piiMessage
      promptBlacklist
      blacklistGroupId
      blacklistMessage
      safety
      safetyGroupId
      safetyMessage
      strongModelGroupId
      routeModel
      trialTokensRemaining
      logfileRetentionPeriod
      callRetentionPeriod
      logInterval
      lastLogGeneratedAt
      logGenerationCursor
      enterpriseAllowChat
      enterpriseAcceptableUsePolicy
      enterpriseAccessRequestEmail
      enterpriseSupportEmail
      enterpriseDomainWhitelist
      enterpriseTokenBudget
      enterpriseTokenBudgetPeriod
      enterpriseImageUrl
      randomGroup
      apiCreditRemaining
      createdAt
      summaryEmailPeriod
      summaryEmailAddresses
      lastSummaryEmailSentAt
      mcpServerWhitelist
      automaticModelManagement
      supersmallGroupModels
      standardGroupModels
      premiumGroupModels
      reasoningGroupModels
      superpremiumGroupModels
      openrouterStandardGroupModels
      openrouterPremiumGroupModels
      azureOpenaiBaseUrl
      azureOpenaiApiVersion
      awsBedrockRegion
      newCustomerUsageTierId
      newCustomerUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      usageTapUsageApiKey
      lowApiCreditNotificationEmails
      lowApiCreditNotificationMinimumCredit
      lastLowApiCreditNotificationSentAt
      integrationApiKey1Hash
      integrationApiKey1Status
      integrationApiKey1Prefix
      integrationApiKey1LastRotatedAt
      integrationApiKey1Scopes
      integrationApiKey2Hash
      integrationApiKey2Status
      integrationApiKey2Prefix
      integrationApiKey2LastRotatedAt
      integrationApiKey2Scopes
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMUserQueryVariables,
  APITypes.GetLLMUserQuery
>;
export const listLLMUsers = /* GraphQL */ `query ListLLMUsers(
  $filter: ModelLLMUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      status
      displayName
      acceptedTermsOfService
      acceptedGDPRTerms
      projectId
      project {
        id
        name
        status
        description
        users {
          nextToken
          __typename
        }
        services {
          nextToken
          __typename
        }
        stripeCustomerId
        subscription {
          id
          projectId
          quantity
          subscriptionId
          subscriptionStartDate
          subscriptionEndDate
          subscriptionStatus
          subscriptionProduct
          subscriptionInterval
          subscriptionEndedAt
          subscriptionCancelAtPeriodEnd
          usageSubscriptionId
          createdAt
          updatedAt
          __typename
        }
        newCustomerTokenCount
        cacheResponsesForSeconds
        loadSheddingTier
        newCustomerLoadSheddingTier
        maintenanceMode
        maintenanceModeMessage
        loadBalancingMode
        piiRedactionScope
        systemInstructions
        piiScope
        piiGroupId
        piiMessage
        promptBlacklist
        blacklistGroupId
        blacklistMessage
        safety
        safetyGroupId
        safetyMessage
        strongModelGroupId
        routeModel
        trialTokensRemaining
        logfileRetentionPeriod
        callRetentionPeriod
        logInterval
        lastLogGeneratedAt
        logGenerationCursor
        enterpriseAllowChat
        enterpriseAcceptableUsePolicy
        enterpriseAccessRequestEmail
        enterpriseSupportEmail
        enterpriseDomainWhitelist
        enterpriseTokenBudget
        enterpriseTokenBudgetPeriod
        enterpriseImageUrl
        randomGroup
        apiCreditRemaining
        createdAt
        summaryEmailPeriod
        summaryEmailAddresses
        lastSummaryEmailSentAt
        mcpServerWhitelist
        automaticModelManagement
        supersmallGroupModels
        standardGroupModels
        premiumGroupModels
        reasoningGroupModels
        superpremiumGroupModels
        openrouterStandardGroupModels
        openrouterPremiumGroupModels
        azureOpenaiBaseUrl
        azureOpenaiApiVersion
        awsBedrockRegion
        newCustomerUsageTierId
        newCustomerUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        usageTapUsageApiKey
        lowApiCreditNotificationEmails
        lowApiCreditNotificationMinimumCredit
        lastLowApiCreditNotificationSentAt
        integrationApiKey1Hash
        integrationApiKey1Status
        integrationApiKey1Prefix
        integrationApiKey1LastRotatedAt
        integrationApiKey1Scopes
        integrationApiKey2Hash
        integrationApiKey2Status
        integrationApiKey2Prefix
        integrationApiKey2LastRotatedAt
        integrationApiKey2Scopes
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMUsersQueryVariables,
  APITypes.ListLLMUsersQuery
>;
export const usersByEmail = /* GraphQL */ `query UsersByEmail(
  $email: String!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByEmail(
    email: $email
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      status
      displayName
      acceptedTermsOfService
      acceptedGDPRTerms
      projectId
      project {
        id
        name
        status
        description
        users {
          nextToken
          __typename
        }
        services {
          nextToken
          __typename
        }
        stripeCustomerId
        subscription {
          id
          projectId
          quantity
          subscriptionId
          subscriptionStartDate
          subscriptionEndDate
          subscriptionStatus
          subscriptionProduct
          subscriptionInterval
          subscriptionEndedAt
          subscriptionCancelAtPeriodEnd
          usageSubscriptionId
          createdAt
          updatedAt
          __typename
        }
        newCustomerTokenCount
        cacheResponsesForSeconds
        loadSheddingTier
        newCustomerLoadSheddingTier
        maintenanceMode
        maintenanceModeMessage
        loadBalancingMode
        piiRedactionScope
        systemInstructions
        piiScope
        piiGroupId
        piiMessage
        promptBlacklist
        blacklistGroupId
        blacklistMessage
        safety
        safetyGroupId
        safetyMessage
        strongModelGroupId
        routeModel
        trialTokensRemaining
        logfileRetentionPeriod
        callRetentionPeriod
        logInterval
        lastLogGeneratedAt
        logGenerationCursor
        enterpriseAllowChat
        enterpriseAcceptableUsePolicy
        enterpriseAccessRequestEmail
        enterpriseSupportEmail
        enterpriseDomainWhitelist
        enterpriseTokenBudget
        enterpriseTokenBudgetPeriod
        enterpriseImageUrl
        randomGroup
        apiCreditRemaining
        createdAt
        summaryEmailPeriod
        summaryEmailAddresses
        lastSummaryEmailSentAt
        mcpServerWhitelist
        automaticModelManagement
        supersmallGroupModels
        standardGroupModels
        premiumGroupModels
        reasoningGroupModels
        superpremiumGroupModels
        openrouterStandardGroupModels
        openrouterPremiumGroupModels
        azureOpenaiBaseUrl
        azureOpenaiApiVersion
        awsBedrockRegion
        newCustomerUsageTierId
        newCustomerUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        usageTapUsageApiKey
        lowApiCreditNotificationEmails
        lowApiCreditNotificationMinimumCredit
        lastLowApiCreditNotificationSentAt
        integrationApiKey1Hash
        integrationApiKey1Status
        integrationApiKey1Prefix
        integrationApiKey1LastRotatedAt
        integrationApiKey1Scopes
        integrationApiKey2Hash
        integrationApiKey2Status
        integrationApiKey2Prefix
        integrationApiKey2LastRotatedAt
        integrationApiKey2Scopes
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByEmailQueryVariables,
  APITypes.UsersByEmailQuery
>;
export const usersByProjectId = /* GraphQL */ `query UsersByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMUserFilterInput
  $limit: Int
  $nextToken: String
) {
  usersByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      email
      status
      displayName
      acceptedTermsOfService
      acceptedGDPRTerms
      projectId
      project {
        id
        name
        status
        description
        users {
          nextToken
          __typename
        }
        services {
          nextToken
          __typename
        }
        stripeCustomerId
        subscription {
          id
          projectId
          quantity
          subscriptionId
          subscriptionStartDate
          subscriptionEndDate
          subscriptionStatus
          subscriptionProduct
          subscriptionInterval
          subscriptionEndedAt
          subscriptionCancelAtPeriodEnd
          usageSubscriptionId
          createdAt
          updatedAt
          __typename
        }
        newCustomerTokenCount
        cacheResponsesForSeconds
        loadSheddingTier
        newCustomerLoadSheddingTier
        maintenanceMode
        maintenanceModeMessage
        loadBalancingMode
        piiRedactionScope
        systemInstructions
        piiScope
        piiGroupId
        piiMessage
        promptBlacklist
        blacklistGroupId
        blacklistMessage
        safety
        safetyGroupId
        safetyMessage
        strongModelGroupId
        routeModel
        trialTokensRemaining
        logfileRetentionPeriod
        callRetentionPeriod
        logInterval
        lastLogGeneratedAt
        logGenerationCursor
        enterpriseAllowChat
        enterpriseAcceptableUsePolicy
        enterpriseAccessRequestEmail
        enterpriseSupportEmail
        enterpriseDomainWhitelist
        enterpriseTokenBudget
        enterpriseTokenBudgetPeriod
        enterpriseImageUrl
        randomGroup
        apiCreditRemaining
        createdAt
        summaryEmailPeriod
        summaryEmailAddresses
        lastSummaryEmailSentAt
        mcpServerWhitelist
        automaticModelManagement
        supersmallGroupModels
        standardGroupModels
        premiumGroupModels
        reasoningGroupModels
        superpremiumGroupModels
        openrouterStandardGroupModels
        openrouterPremiumGroupModels
        azureOpenaiBaseUrl
        azureOpenaiApiVersion
        awsBedrockRegion
        newCustomerUsageTierId
        newCustomerUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        usageTapUsageApiKey
        lowApiCreditNotificationEmails
        lowApiCreditNotificationMinimumCredit
        lastLowApiCreditNotificationSentAt
        integrationApiKey1Hash
        integrationApiKey1Status
        integrationApiKey1Prefix
        integrationApiKey1LastRotatedAt
        integrationApiKey1Scopes
        integrationApiKey2Hash
        integrationApiKey2Status
        integrationApiKey2Prefix
        integrationApiKey2LastRotatedAt
        integrationApiKey2Scopes
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UsersByProjectIdQueryVariables,
  APITypes.UsersByProjectIdQuery
>;
export const getLLMService = /* GraphQL */ `query GetLLMService($id: ID!) {
  getLLMService(id: $id) {
    id
    name
    status
    vendor
    region
    endpoint
    body
    header
    projectId
    loadProportion
    inputTokenPricePerMillion
    outputTokenPricePerMillion
    groupId
    group {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMServiceQueryVariables,
  APITypes.GetLLMServiceQuery
>;
export const listLLMServices = /* GraphQL */ `query ListLLMServices(
  $filter: ModelLLMServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMServicesQueryVariables,
  APITypes.ListLLMServicesQuery
>;
export const servicesByProjectId = /* GraphQL */ `query ServicesByProjectId(
  $projectId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  servicesByProjectId(
    projectId: $projectId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ServicesByProjectIdQueryVariables,
  APITypes.ServicesByProjectIdQuery
>;
export const getLLMGroup = /* GraphQL */ `query GetLLMGroup($id: ID!) {
  getLLMGroup(id: $id) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    order
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMGroupQueryVariables,
  APITypes.GetLLMGroupQuery
>;
export const listLLMGroups = /* GraphQL */ `query ListLLMGroups(
  $filter: ModelLLMGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMGroupsQueryVariables,
  APITypes.ListLLMGroupsQuery
>;
export const groupsByProjectId = /* GraphQL */ `query GroupsByProjectId(
  $projectId: ID!
  $order: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  groupsByProjectId(
    projectId: $projectId
    order: $order
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      order
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GroupsByProjectIdQueryVariables,
  APITypes.GroupsByProjectIdQuery
>;
export const getLLMCustomer = /* GraphQL */ `query GetLLMCustomer($id: ID!) {
  getLLMCustomer(id: $id) {
    id
    name
    status
    tokensRemaining
    lastCallMadeAt
    numberOfCallsMade
    projectId
    loadSheddingTier
    dataResidency
    createdAt
    enterpriseUser
    tokenReplenishmentAmount
    tokenReplenishmentPeriod
    lastReplenishedAt
    nextReplenishAt
    usageTierId
    usageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierId
    nextUsageTier {
      id
      projectId
      status
      name
      description
      version
      activeAt
      inactiveAt
      priorUsageTierId
      priorUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      baseUsageTierId
      baseUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      replenishmentPeriod
      replenishmentMethod
      usageLimitAction
      standardTokenReplenishmentAmount
      premiumTokenReplenishmentAmount
      superPremiumTokenReplenishmentAmount
      reasoningTokenReplenishmentAmount
      standardCallReplenishmentAmount
      premiumCallReplenishmentAmount
      superPremiumCallReplenishmentAmount
      reasoningCallReplenishmentAmount
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      createdAt
      updatedAt
      __typename
    }
    nextUsageTierAt
    usageLimitAction
    standardTokensRemaining
    premiumTokensRemaining
    superPremiumTokensRemaining
    reasoningTokensRemaining
    standardCallsRemaining
    premiumCallsRemaining
    superPremiumCallsRemaining
    reasoningCallsRemaining
    standardTokenUnlimited
    premiumTokenUnlimited
    superPremiumTokenUnlimited
    reasoningTokenUnlimited
    standardCallUnlimited
    premiumCallUnlimited
    superPremiumCallUnlimited
    reasoningCallUnlimited
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMCustomerQueryVariables,
  APITypes.GetLLMCustomerQuery
>;
export const listLLMCustomers = /* GraphQL */ `query ListLLMCustomers(
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMCustomersQueryVariables,
  APITypes.ListLLMCustomersQuery
>;
export const customersByStatus = /* GraphQL */ `query CustomersByStatus(
  $status: String!
  $nextReplenishAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customersByStatus(
    status: $status
    nextReplenishAt: $nextReplenishAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomersByStatusQueryVariables,
  APITypes.CustomersByStatusQuery
>;
export const customersByProjectIdAndLastCallMadeAt = /* GraphQL */ `query CustomersByProjectIdAndLastCallMadeAt(
  $projectId: ID!
  $lastCallMadeAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customersByProjectIdAndLastCallMadeAt(
    projectId: $projectId
    lastCallMadeAt: $lastCallMadeAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomersByProjectIdAndLastCallMadeAtQueryVariables,
  APITypes.CustomersByProjectIdAndLastCallMadeAtQuery
>;
export const customersByProjectIdAndCreatedAt = /* GraphQL */ `query CustomersByProjectIdAndCreatedAt(
  $projectId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customersByProjectIdAndCreatedAt(
    projectId: $projectId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomersByProjectIdAndCreatedAtQueryVariables,
  APITypes.CustomersByProjectIdAndCreatedAtQuery
>;
export const customersByProjectIdAndTokensRemaining = /* GraphQL */ `query CustomersByProjectIdAndTokensRemaining(
  $projectId: ID!
  $tokensRemaining: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customersByProjectIdAndTokensRemaining(
    projectId: $projectId
    tokensRemaining: $tokensRemaining
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomersByProjectIdAndTokensRemainingQueryVariables,
  APITypes.CustomersByProjectIdAndTokensRemainingQuery
>;
export const customersByTokenReplenishmentPeriodAndLastReplenishedAt = /* GraphQL */ `query CustomersByTokenReplenishmentPeriodAndLastReplenishedAt(
  $tokenReplenishmentPeriod: String!
  $lastReplenishedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customersByTokenReplenishmentPeriodAndLastReplenishedAt(
    tokenReplenishmentPeriod: $tokenReplenishmentPeriod
    lastReplenishedAt: $lastReplenishedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomersByTokenReplenishmentPeriodAndLastReplenishedAtQueryVariables,
  APITypes.CustomersByTokenReplenishmentPeriodAndLastReplenishedAtQuery
>;
export const customersByUsageTierIdAndNextReplenishAt = /* GraphQL */ `query CustomersByUsageTierIdAndNextReplenishAt(
  $usageTierId: ID!
  $nextReplenishAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCustomerFilterInput
  $limit: Int
  $nextToken: String
) {
  customersByUsageTierIdAndNextReplenishAt(
    usageTierId: $usageTierId
    nextReplenishAt: $nextReplenishAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CustomersByUsageTierIdAndNextReplenishAtQueryVariables,
  APITypes.CustomersByUsageTierIdAndNextReplenishAtQuery
>;
export const getLLMCall = /* GraphQL */ `query GetLLMCall($id: ID!) {
  getLLMCall(id: $id) {
    id
    projectId
    status
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    serviceId
    service {
      id
      name
      status
      vendor
      region
      endpoint
      body
      header
      projectId
      loadProportion
      inputTokenPricePerMillion
      outputTokenPricePerMillion
      groupId
      group {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        order
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    modelId
    model {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    requestHash
    messages
    prompt
    response
    tokenCountPrompt
    tokenCountResponse
    createdAt
    hash
    country
    region
    city
    quality
    qualityComment
    apiKeyType
    toxicity
    randomGroup
    agentId
    conversationId
    timings
    customer_user_id
    customer_user_name
    customer_user_email
    batch
    callbackUrl
    batchId
    batchCustomId
    batchRequest
    executionMode
    pricingMode
    vendorBatchId
    vendorResponseId
    vendorStatus
    resolvedModelId
    usageTapCallId
    usageTapStripeCustomerId
    error
    cacheReadTokens
    cacheWriteTokens
    cacheStatus
    compactionTriggered
    compactionTokensSaved
    curatedTokensSaved
    curatedItems
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMCallQueryVariables,
  APITypes.GetLLMCallQuery
>;
export const listLLMCalls = /* GraphQL */ `query ListLLMCalls(
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMCalls(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMCallsQueryVariables,
  APITypes.ListLLMCallsQuery
>;
export const callsByProjectIdAndCreatedAt = /* GraphQL */ `query CallsByProjectIdAndCreatedAt(
  $projectId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByProjectIdAndCreatedAt(
    projectId: $projectId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByProjectIdAndCreatedAtQueryVariables,
  APITypes.CallsByProjectIdAndCreatedAtQuery
>;
export const callsByCustomerIdAndCreatedAt = /* GraphQL */ `query CallsByCustomerIdAndCreatedAt(
  $customerId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByCustomerIdAndCreatedAt(
    customerId: $customerId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByCustomerIdAndCreatedAtQueryVariables,
  APITypes.CallsByCustomerIdAndCreatedAtQuery
>;
export const callsByHashAndCreatedAt = /* GraphQL */ `query CallsByHashAndCreatedAt(
  $hash: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByHashAndCreatedAt(
    hash: $hash
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByHashAndCreatedAtQueryVariables,
  APITypes.CallsByHashAndCreatedAtQuery
>;
export const callsByRandomGroupAndCreatedAt = /* GraphQL */ `query CallsByRandomGroupAndCreatedAt(
  $randomGroup: Int!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByRandomGroupAndCreatedAt(
    randomGroup: $randomGroup
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByRandomGroupAndCreatedAtQueryVariables,
  APITypes.CallsByRandomGroupAndCreatedAtQuery
>;
export const callsByAgentIdAndCreatedAt = /* GraphQL */ `query CallsByAgentIdAndCreatedAt(
  $agentId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByAgentIdAndCreatedAt(
    agentId: $agentId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByAgentIdAndCreatedAtQueryVariables,
  APITypes.CallsByAgentIdAndCreatedAtQuery
>;
export const callsByConversationIdAndCreatedAt = /* GraphQL */ `query CallsByConversationIdAndCreatedAt(
  $conversationId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByConversationIdAndCreatedAt(
    conversationId: $conversationId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByConversationIdAndCreatedAtQueryVariables,
  APITypes.CallsByConversationIdAndCreatedAtQuery
>;
export const callsByBatchIdAndCreatedAt = /* GraphQL */ `query CallsByBatchIdAndCreatedAt(
  $batchId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallFilterInput
  $limit: Int
  $nextToken: String
) {
  callsByBatchIdAndCreatedAt(
    batchId: $batchId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      serviceId
      service {
        id
        name
        status
        vendor
        region
        endpoint
        body
        header
        projectId
        loadProportion
        inputTokenPricePerMillion
        outputTokenPricePerMillion
        groupId
        group {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          order
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      modelId
      model {
        id
        status
        vendor
        host
        supported
        name
        description
        modelKey
        modelKeyLatest
        inputTokenPrice
        cachedTokenPrice
        outputTokenPrice
        inputTokenBatchPrice
        outputTokenBatchPrice
        searchCost
        supportsSearch
        textInputSupport
        imageInputSupport
        audioInputSupport
        textOutputSupport
        imageOutputSupport
        audioOutputSupport
        thinkingSupport
        contextWindowTokens
        maxResponseTokens
        knowledgeCutoffDate
        lastCheckedDate
        supportedLanguages
        warningDate
        warningMessage
        deprecationDate
        deprecationMessage
        defaultServiceGroup
        defaultEnabled
        displayOrder
        recommendedUseCase
        performanceRating
        createdAt
        updatedAt
        __typename
      }
      requestHash
      messages
      prompt
      response
      tokenCountPrompt
      tokenCountResponse
      createdAt
      hash
      country
      region
      city
      quality
      qualityComment
      apiKeyType
      toxicity
      randomGroup
      agentId
      conversationId
      timings
      customer_user_id
      customer_user_name
      customer_user_email
      batch
      callbackUrl
      batchId
      batchCustomId
      batchRequest
      executionMode
      pricingMode
      vendorBatchId
      vendorResponseId
      vendorStatus
      resolvedModelId
      usageTapCallId
      usageTapStripeCustomerId
      error
      cacheReadTokens
      cacheWriteTokens
      cacheStatus
      compactionTriggered
      compactionTokensSaved
      curatedTokensSaved
      curatedItems
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallsByBatchIdAndCreatedAtQueryVariables,
  APITypes.CallsByBatchIdAndCreatedAtQuery
>;
export const getLLMBatch = /* GraphQL */ `query GetLLMBatch($id: ID!) {
  getLLMBatch(id: $id) {
    id
    projectId
    status
    vendor
    vendorBatchId
    vendorInputFileId
    vendorOutputFileId
    vendorErrorFileId
    requestCount
    completedCount
    failedCount
    nextPollAt
    callbackUrl
    callbackSecret
    callbackStatus
    callbackAttempts
    callbackLastError
    idempotencyKeyHash
    requestHash
    error
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMBatchQueryVariables,
  APITypes.GetLLMBatchQuery
>;
export const listLLMBatches = /* GraphQL */ `query ListLLMBatches(
  $filter: ModelLLMBatchFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMBatches(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      status
      vendor
      vendorBatchId
      vendorInputFileId
      vendorOutputFileId
      vendorErrorFileId
      requestCount
      completedCount
      failedCount
      nextPollAt
      callbackUrl
      callbackSecret
      callbackStatus
      callbackAttempts
      callbackLastError
      idempotencyKeyHash
      requestHash
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMBatchesQueryVariables,
  APITypes.ListLLMBatchesQuery
>;
export const batchesByProjectIdAndCreatedAt = /* GraphQL */ `query BatchesByProjectIdAndCreatedAt(
  $projectId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMBatchFilterInput
  $limit: Int
  $nextToken: String
) {
  batchesByProjectIdAndCreatedAt(
    projectId: $projectId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      vendor
      vendorBatchId
      vendorInputFileId
      vendorOutputFileId
      vendorErrorFileId
      requestCount
      completedCount
      failedCount
      nextPollAt
      callbackUrl
      callbackSecret
      callbackStatus
      callbackAttempts
      callbackLastError
      idempotencyKeyHash
      requestHash
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BatchesByProjectIdAndCreatedAtQueryVariables,
  APITypes.BatchesByProjectIdAndCreatedAtQuery
>;
export const batchesByStatusAndNextPollAt = /* GraphQL */ `query BatchesByStatusAndNextPollAt(
  $status: String!
  $nextPollAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMBatchFilterInput
  $limit: Int
  $nextToken: String
) {
  batchesByStatusAndNextPollAt(
    status: $status
    nextPollAt: $nextPollAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      vendor
      vendorBatchId
      vendorInputFileId
      vendorOutputFileId
      vendorErrorFileId
      requestCount
      completedCount
      failedCount
      nextPollAt
      callbackUrl
      callbackSecret
      callbackStatus
      callbackAttempts
      callbackLastError
      idempotencyKeyHash
      requestHash
      error
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BatchesByStatusAndNextPollAtQueryVariables,
  APITypes.BatchesByStatusAndNextPollAtQuery
>;
export const getLLMPrompt = /* GraphQL */ `query GetLLMPrompt($id: ID!) {
  getLLMPrompt(id: $id) {
    id
    projectId
    status
    name
    description
    prompt
    key
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMPromptQueryVariables,
  APITypes.GetLLMPromptQuery
>;
export const listLLMPrompts = /* GraphQL */ `query ListLLMPrompts(
  $filter: ModelLLMPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMPrompts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      status
      name
      description
      prompt
      key
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMPromptsQueryVariables,
  APITypes.ListLLMPromptsQuery
>;
export const promptsByProjectIdAndKey = /* GraphQL */ `query PromptsByProjectIdAndKey(
  $projectId: ID!
  $key: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  promptsByProjectIdAndKey(
    projectId: $projectId
    key: $key
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      name
      description
      prompt
      key
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromptsByProjectIdAndKeyQueryVariables,
  APITypes.PromptsByProjectIdAndKeyQuery
>;
export const getLLMCallLogFile = /* GraphQL */ `query GetLLMCallLogFile($id: ID!) {
  getLLMCallLogFile(id: $id) {
    id
    projectId
    fromDate
    toDate
    chunk
    count
    status
    bucket
    key
    url
    urlExpiresAt
    deleteFileAfter
    createdAt
    randomGroup
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMCallLogFileQueryVariables,
  APITypes.GetLLMCallLogFileQuery
>;
export const listLLMCallLogFiles = /* GraphQL */ `query ListLLMCallLogFiles(
  $filter: ModelLLMCallLogFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMCallLogFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      fromDate
      toDate
      chunk
      count
      status
      bucket
      key
      url
      urlExpiresAt
      deleteFileAfter
      createdAt
      randomGroup
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMCallLogFilesQueryVariables,
  APITypes.ListLLMCallLogFilesQuery
>;
export const callLogFilesByProjectIdAndCreatedAt = /* GraphQL */ `query CallLogFilesByProjectIdAndCreatedAt(
  $projectId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallLogFileFilterInput
  $limit: Int
  $nextToken: String
) {
  callLogFilesByProjectIdAndCreatedAt(
    projectId: $projectId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      fromDate
      toDate
      chunk
      count
      status
      bucket
      key
      url
      urlExpiresAt
      deleteFileAfter
      createdAt
      randomGroup
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallLogFilesByProjectIdAndCreatedAtQueryVariables,
  APITypes.CallLogFilesByProjectIdAndCreatedAtQuery
>;
export const callLogFilesByRandomGroupAndDeleteFileAfter = /* GraphQL */ `query CallLogFilesByRandomGroupAndDeleteFileAfter(
  $randomGroup: Int!
  $deleteFileAfter: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMCallLogFileFilterInput
  $limit: Int
  $nextToken: String
) {
  callLogFilesByRandomGroupAndDeleteFileAfter(
    randomGroup: $randomGroup
    deleteFileAfter: $deleteFileAfter
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      fromDate
      toDate
      chunk
      count
      status
      bucket
      key
      url
      urlExpiresAt
      deleteFileAfter
      createdAt
      randomGroup
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CallLogFilesByRandomGroupAndDeleteFileAfterQueryVariables,
  APITypes.CallLogFilesByRandomGroupAndDeleteFileAfterQuery
>;
export const getLLMAgent = /* GraphQL */ `query GetLLMAgent($id: ID!) {
  getLLMAgent(id: $id) {
    id
    status
    name
    description
    projectId
    systemInstructions
    systemInstructionsAction
    displayTheme
    cssUrl
    displayTitle
    displayStartMessageOrPrompt
    displayInitialMessageOrPrompt
    displayPromptTemplate
    displayFollowOnPrompts
    displayActions
    displayWidth
    displayHeight
    displayPlaceholder
    displayHideInitialPrompt
    displayShowSaveButton
    displayShowEmailButton
    displayShowCallToAction
    displayCallToActionButtonText
    displayCallToActionEmailAddress
    displayCallToActionEmailSubject
    displayCallToActionMustSendEmail
    displayScrollToEnd
    groupId
    data
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    documents {
      items {
        id
        projectId
        agentId
        status
        fileName
        fileSize
        fileType
        uploadDate
        uploader
        lastModifiedDate
        ownershipAttestation
        location
        type
        ragSplitter
        ragChunkSize
        ragChunkOverlap
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    mcpServers {
      items {
        id
        projectId
        agentId
        status
        approvalMode
        executionMode
        url
        accessToken
        headers
        stdioCommand
        stdioArgs
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    ragQueryLimit
    ragRankLimit
    ragIncludeCitations
    ragDoRerank
    ragSkipChecksOnContext
    ragShadowRead
    visibility
    createConversationOnFirstChat
    customerEmailCaptureMode
    customerEmailCapturePlaceholder
    enableRAG
    enableMCP
    injectMemories
    injectKnowledgeGraph
    enableWebSearch
    linkedFileTypes
    thinkingDepth
    enablePromptCaching
    compactionPolicy
    compactionThreshold
    curateToolResults
    curateAfterTurns
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMAgentQueryVariables,
  APITypes.GetLLMAgentQuery
>;
export const listLLMAgents = /* GraphQL */ `query ListLLMAgents(
  $filter: ModelLLMAgentFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMAgents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMAgentsQueryVariables,
  APITypes.ListLLMAgentsQuery
>;
export const agentsByProjectId = /* GraphQL */ `query AgentsByProjectId(
  $projectId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMAgentFilterInput
  $limit: Int
  $nextToken: String
) {
  agentsByProjectId(
    projectId: $projectId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AgentsByProjectIdQueryVariables,
  APITypes.AgentsByProjectIdQuery
>;
export const getLLMAgentMCP = /* GraphQL */ `query GetLLMAgentMCP($id: ID!) {
  getLLMAgentMCP(id: $id) {
    id
    projectId
    agentId
    status
    approvalMode
    executionMode
    url
    accessToken
    headers
    stdioCommand
    stdioArgs
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMAgentMCPQueryVariables,
  APITypes.GetLLMAgentMCPQuery
>;
export const listLLMAgentMCPS = /* GraphQL */ `query ListLLMAgentMCPS(
  $filter: ModelLLMAgentMCPFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMAgentMCPS(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      agentId
      status
      approvalMode
      executionMode
      url
      accessToken
      headers
      stdioCommand
      stdioArgs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMAgentMCPSQueryVariables,
  APITypes.ListLLMAgentMCPSQuery
>;
export const agentMCPByAgentId = /* GraphQL */ `query AgentMCPByAgentId(
  $agentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMAgentMCPFilterInput
  $limit: Int
  $nextToken: String
) {
  agentMCPByAgentId(
    agentId: $agentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      status
      approvalMode
      executionMode
      url
      accessToken
      headers
      stdioCommand
      stdioArgs
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AgentMCPByAgentIdQueryVariables,
  APITypes.AgentMCPByAgentIdQuery
>;
export const getLLMAgentDocument = /* GraphQL */ `query GetLLMAgentDocument($id: ID!) {
  getLLMAgentDocument(id: $id) {
    id
    projectId
    agentId
    status
    fileName
    fileSize
    fileType
    uploadDate
    uploader
    lastModifiedDate
    ownershipAttestation
    location
    type
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMAgentDocumentQueryVariables,
  APITypes.GetLLMAgentDocumentQuery
>;
export const listLLMAgentDocuments = /* GraphQL */ `query ListLLMAgentDocuments(
  $filter: ModelLLMAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMAgentDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      agentId
      status
      fileName
      fileSize
      fileType
      uploadDate
      uploader
      lastModifiedDate
      ownershipAttestation
      location
      type
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMAgentDocumentsQueryVariables,
  APITypes.ListLLMAgentDocumentsQuery
>;
export const agentDocumentsByProjectId = /* GraphQL */ `query AgentDocumentsByProjectId(
  $projectId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  agentDocumentsByProjectId(
    projectId: $projectId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      status
      fileName
      fileSize
      fileType
      uploadDate
      uploader
      lastModifiedDate
      ownershipAttestation
      location
      type
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AgentDocumentsByProjectIdQueryVariables,
  APITypes.AgentDocumentsByProjectIdQuery
>;
export const agentDocumentsByAgentId = /* GraphQL */ `query AgentDocumentsByAgentId(
  $agentId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  agentDocumentsByAgentId(
    agentId: $agentId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      status
      fileName
      fileSize
      fileType
      uploadDate
      uploader
      lastModifiedDate
      ownershipAttestation
      location
      type
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AgentDocumentsByAgentIdQueryVariables,
  APITypes.AgentDocumentsByAgentIdQuery
>;
export const getLLMOpenAIAgentDocument = /* GraphQL */ `query GetLLMOpenAIAgentDocument($id: ID!) {
  getLLMOpenAIAgentDocument(id: $id) {
    id
    projectId
    projectBackend
    documentId
    agentId
    backend
    status
    vectorStoreId
    openaiFileIds
    sourceType
    sourceLocation
    fileName
    fileType
    ragSplitter
    ragChunkSize
    ragChunkOverlap
    chunkCount
    providerVersion
    lastError
    createdAt
    updatedAt
    readyAt
    deletedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMOpenAIAgentDocumentQueryVariables,
  APITypes.GetLLMOpenAIAgentDocumentQuery
>;
export const listLLMOpenAIAgentDocuments = /* GraphQL */ `query ListLLMOpenAIAgentDocuments(
  $filter: ModelLLMOpenAIAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMOpenAIAgentDocuments(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      projectBackend
      documentId
      agentId
      backend
      status
      vectorStoreId
      openaiFileIds
      sourceType
      sourceLocation
      fileName
      fileType
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      chunkCount
      providerVersion
      lastError
      createdAt
      updatedAt
      readyAt
      deletedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMOpenAIAgentDocumentsQueryVariables,
  APITypes.ListLLMOpenAIAgentDocumentsQuery
>;
export const openAIAgentDocumentsByProjectId = /* GraphQL */ `query OpenAIAgentDocumentsByProjectId(
  $projectId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenAIAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  openAIAgentDocumentsByProjectId(
    projectId: $projectId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      projectBackend
      documentId
      agentId
      backend
      status
      vectorStoreId
      openaiFileIds
      sourceType
      sourceLocation
      fileName
      fileType
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      chunkCount
      providerVersion
      lastError
      createdAt
      updatedAt
      readyAt
      deletedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenAIAgentDocumentsByProjectIdQueryVariables,
  APITypes.OpenAIAgentDocumentsByProjectIdQuery
>;
export const openAIAgentDocumentsByProjectBackend = /* GraphQL */ `query OpenAIAgentDocumentsByProjectBackend(
  $projectBackend: String!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenAIAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  openAIAgentDocumentsByProjectBackend(
    projectBackend: $projectBackend
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      projectBackend
      documentId
      agentId
      backend
      status
      vectorStoreId
      openaiFileIds
      sourceType
      sourceLocation
      fileName
      fileType
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      chunkCount
      providerVersion
      lastError
      createdAt
      updatedAt
      readyAt
      deletedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenAIAgentDocumentsByProjectBackendQueryVariables,
  APITypes.OpenAIAgentDocumentsByProjectBackendQuery
>;
export const openAIAgentDocumentsByDocumentId = /* GraphQL */ `query OpenAIAgentDocumentsByDocumentId(
  $documentId: ID!
  $backend: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenAIAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  openAIAgentDocumentsByDocumentId(
    documentId: $documentId
    backend: $backend
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      projectBackend
      documentId
      agentId
      backend
      status
      vectorStoreId
      openaiFileIds
      sourceType
      sourceLocation
      fileName
      fileType
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      chunkCount
      providerVersion
      lastError
      createdAt
      updatedAt
      readyAt
      deletedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenAIAgentDocumentsByDocumentIdQueryVariables,
  APITypes.OpenAIAgentDocumentsByDocumentIdQuery
>;
export const openAIAgentDocumentsByAgentId = /* GraphQL */ `query OpenAIAgentDocumentsByAgentId(
  $agentId: ID!
  $backend: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenAIAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  openAIAgentDocumentsByAgentId(
    agentId: $agentId
    backend: $backend
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      projectBackend
      documentId
      agentId
      backend
      status
      vectorStoreId
      openaiFileIds
      sourceType
      sourceLocation
      fileName
      fileType
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      chunkCount
      providerVersion
      lastError
      createdAt
      updatedAt
      readyAt
      deletedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenAIAgentDocumentsByAgentIdQueryVariables,
  APITypes.OpenAIAgentDocumentsByAgentIdQuery
>;
export const openAIAgentDocumentsByStatus = /* GraphQL */ `query OpenAIAgentDocumentsByStatus(
  $status: String!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenAIAgentDocumentFilterInput
  $limit: Int
  $nextToken: String
) {
  openAIAgentDocumentsByStatus(
    status: $status
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      projectBackend
      documentId
      agentId
      backend
      status
      vectorStoreId
      openaiFileIds
      sourceType
      sourceLocation
      fileName
      fileType
      ragSplitter
      ragChunkSize
      ragChunkOverlap
      chunkCount
      providerVersion
      lastError
      createdAt
      updatedAt
      readyAt
      deletedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenAIAgentDocumentsByStatusQueryVariables,
  APITypes.OpenAIAgentDocumentsByStatusQuery
>;
export const getLLMConversation = /* GraphQL */ `query GetLLMConversation($id: ID!) {
  getLLMConversation(id: $id) {
    id
    projectId
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    createdAt
    status
    title
    summary
    timezone
    language
    country
    region
    city
    calls {
      items {
        id
        projectId
        status
        customerId
        customer {
          id
          name
          status
          tokensRemaining
          lastCallMadeAt
          numberOfCallsMade
          projectId
          loadSheddingTier
          dataResidency
          createdAt
          enterpriseUser
          tokenReplenishmentAmount
          tokenReplenishmentPeriod
          lastReplenishedAt
          nextReplenishAt
          usageTierId
          nextUsageTierId
          nextUsageTierAt
          usageLimitAction
          standardTokensRemaining
          premiumTokensRemaining
          superPremiumTokensRemaining
          reasoningTokensRemaining
          standardCallsRemaining
          premiumCallsRemaining
          superPremiumCallsRemaining
          reasoningCallsRemaining
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          updatedAt
          __typename
        }
        serviceId
        service {
          id
          name
          status
          vendor
          region
          endpoint
          body
          header
          projectId
          loadProportion
          inputTokenPricePerMillion
          outputTokenPricePerMillion
          groupId
          createdAt
          updatedAt
          __typename
        }
        modelId
        model {
          id
          status
          vendor
          host
          supported
          name
          description
          modelKey
          modelKeyLatest
          inputTokenPrice
          cachedTokenPrice
          outputTokenPrice
          inputTokenBatchPrice
          outputTokenBatchPrice
          searchCost
          supportsSearch
          textInputSupport
          imageInputSupport
          audioInputSupport
          textOutputSupport
          imageOutputSupport
          audioOutputSupport
          thinkingSupport
          contextWindowTokens
          maxResponseTokens
          knowledgeCutoffDate
          lastCheckedDate
          supportedLanguages
          warningDate
          warningMessage
          deprecationDate
          deprecationMessage
          defaultServiceGroup
          defaultEnabled
          displayOrder
          recommendedUseCase
          performanceRating
          createdAt
          updatedAt
          __typename
        }
        requestHash
        messages
        prompt
        response
        tokenCountPrompt
        tokenCountResponse
        createdAt
        hash
        country
        region
        city
        quality
        qualityComment
        apiKeyType
        toxicity
        randomGroup
        agentId
        conversationId
        timings
        customer_user_id
        customer_user_name
        customer_user_email
        batch
        callbackUrl
        batchId
        batchCustomId
        batchRequest
        executionMode
        pricingMode
        vendorBatchId
        vendorResponseId
        vendorStatus
        resolvedModelId
        usageTapCallId
        usageTapStripeCustomerId
        error
        cacheReadTokens
        cacheWriteTokens
        cacheStatus
        compactionTriggered
        compactionTokensSaved
        curatedTokensSaved
        curatedItems
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    emailAddress
    thumbsupClicked
    thumbsdownClicked
    copyClicked
    emailClicked
    saveClicked
    ctaClicked
    suggestionClicked
    actionClicked
    intelligence
    endedAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMConversationQueryVariables,
  APITypes.GetLLMConversationQuery
>;
export const listLLMConversations = /* GraphQL */ `query ListLLMConversations(
  $filter: ModelLLMConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMConversations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      createdAt
      status
      title
      summary
      timezone
      language
      country
      region
      city
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      emailAddress
      thumbsupClicked
      thumbsdownClicked
      copyClicked
      emailClicked
      saveClicked
      ctaClicked
      suggestionClicked
      actionClicked
      intelligence
      endedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMConversationsQueryVariables,
  APITypes.ListLLMConversationsQuery
>;
export const conversationsByProjectIdAndCreatedAt = /* GraphQL */ `query ConversationsByProjectIdAndCreatedAt(
  $projectId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByProjectIdAndCreatedAt(
    projectId: $projectId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      createdAt
      status
      title
      summary
      timezone
      language
      country
      region
      city
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      emailAddress
      thumbsupClicked
      thumbsdownClicked
      copyClicked
      emailClicked
      saveClicked
      ctaClicked
      suggestionClicked
      actionClicked
      intelligence
      endedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByProjectIdAndCreatedAtQueryVariables,
  APITypes.ConversationsByProjectIdAndCreatedAtQuery
>;
export const conversationsByCustomerIdAndCreatedAt = /* GraphQL */ `query ConversationsByCustomerIdAndCreatedAt(
  $customerId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByCustomerIdAndCreatedAt(
    customerId: $customerId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      createdAt
      status
      title
      summary
      timezone
      language
      country
      region
      city
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      emailAddress
      thumbsupClicked
      thumbsdownClicked
      copyClicked
      emailClicked
      saveClicked
      ctaClicked
      suggestionClicked
      actionClicked
      intelligence
      endedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByCustomerIdAndCreatedAtQueryVariables,
  APITypes.ConversationsByCustomerIdAndCreatedAtQuery
>;
export const conversationsByStatusAndCreatedAt = /* GraphQL */ `query ConversationsByStatusAndCreatedAt(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMConversationFilterInput
  $limit: Int
  $nextToken: String
) {
  conversationsByStatusAndCreatedAt(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      createdAt
      status
      title
      summary
      timezone
      language
      country
      region
      city
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      emailAddress
      thumbsupClicked
      thumbsdownClicked
      copyClicked
      emailClicked
      saveClicked
      ctaClicked
      suggestionClicked
      actionClicked
      intelligence
      endedAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ConversationsByStatusAndCreatedAtQueryVariables,
  APITypes.ConversationsByStatusAndCreatedAtQuery
>;
export const getLLMModel = /* GraphQL */ `query GetLLMModel($id: ID!) {
  getLLMModel(id: $id) {
    id
    status
    vendor
    host
    supported
    name
    description
    modelKey
    modelKeyLatest
    inputTokenPrice
    cachedTokenPrice
    outputTokenPrice
    inputTokenBatchPrice
    outputTokenBatchPrice
    searchCost
    supportsSearch
    textInputSupport
    imageInputSupport
    audioInputSupport
    textOutputSupport
    imageOutputSupport
    audioOutputSupport
    thinkingSupport
    contextWindowTokens
    maxResponseTokens
    knowledgeCutoffDate
    lastCheckedDate
    supportedLanguages
    warningDate
    warningMessage
    deprecationDate
    deprecationMessage
    defaultServiceGroup
    defaultEnabled
    displayOrder
    recommendedUseCase
    performanceRating
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMModelQueryVariables,
  APITypes.GetLLMModelQuery
>;
export const listLLMModels = /* GraphQL */ `query ListLLMModels(
  $filter: ModelLLMModelFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMModelsQueryVariables,
  APITypes.ListLLMModelsQuery
>;
export const lLMModelsByHostAndModelKey = /* GraphQL */ `query LLMModelsByHostAndModelKey(
  $host: String!
  $modelKey: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMModelFilterInput
  $limit: Int
  $nextToken: String
) {
  lLMModelsByHostAndModelKey(
    host: $host
    modelKey: $modelKey
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LLMModelsByHostAndModelKeyQueryVariables,
  APITypes.LLMModelsByHostAndModelKeyQuery
>;
export const lLMModelsByHostAndModelKeyLatest = /* GraphQL */ `query LLMModelsByHostAndModelKeyLatest(
  $host: String!
  $modelKeyLatest: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMModelFilterInput
  $limit: Int
  $nextToken: String
) {
  lLMModelsByHostAndModelKeyLatest(
    host: $host
    modelKeyLatest: $modelKeyLatest
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      vendor
      host
      supported
      name
      description
      modelKey
      modelKeyLatest
      inputTokenPrice
      cachedTokenPrice
      outputTokenPrice
      inputTokenBatchPrice
      outputTokenBatchPrice
      searchCost
      supportsSearch
      textInputSupport
      imageInputSupport
      audioInputSupport
      textOutputSupport
      imageOutputSupport
      audioOutputSupport
      thinkingSupport
      contextWindowTokens
      maxResponseTokens
      knowledgeCutoffDate
      lastCheckedDate
      supportedLanguages
      warningDate
      warningMessage
      deprecationDate
      deprecationMessage
      defaultServiceGroup
      defaultEnabled
      displayOrder
      recommendedUseCase
      performanceRating
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LLMModelsByHostAndModelKeyLatestQueryVariables,
  APITypes.LLMModelsByHostAndModelKeyLatestQuery
>;
export const getLLMProvider = /* GraphQL */ `query GetLLMProvider($id: ID!) {
  getLLMProvider(id: $id) {
    id
    displayName
    contactUrl
    description
    defaultIsModerated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMProviderQueryVariables,
  APITypes.GetLLMProviderQuery
>;
export const listLLMProviders = /* GraphQL */ `query ListLLMProviders(
  $filter: ModelLLMProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      displayName
      contactUrl
      description
      defaultIsModerated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMProvidersQueryVariables,
  APITypes.ListLLMProvidersQuery
>;
export const providersByDisplayName = /* GraphQL */ `query ProvidersByDisplayName(
  $displayName: String!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  providersByDisplayName(
    displayName: $displayName
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      displayName
      contactUrl
      description
      defaultIsModerated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProvidersByDisplayNameQueryVariables,
  APITypes.ProvidersByDisplayNameQuery
>;
export const getLLMOpenRouterModel = /* GraphQL */ `query GetLLMOpenRouterModel($id: ID!) {
  getLLMOpenRouterModel(id: $id) {
    id
    providerId
    provider {
      id
      displayName
      contactUrl
      description
      defaultIsModerated
      createdAt
      updatedAt
      __typename
    }
    canonicalSlug
    name
    description
    tokenizer
    instructType
    contextLength
    maxCompletionTokens
    isModerated
    architectureModality
    architectureInputModalities
    architectureOutputModalities
    supportedParameters
    defaultParameters
    huggingFaceId
    latestPricingSnapshotId
    isDeprecated
    deprecatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMOpenRouterModelQueryVariables,
  APITypes.GetLLMOpenRouterModelQuery
>;
export const listLLMOpenRouterModels = /* GraphQL */ `query ListLLMOpenRouterModels(
  $filter: ModelLLMOpenRouterModelFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMOpenRouterModels(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMOpenRouterModelsQueryVariables,
  APITypes.ListLLMOpenRouterModelsQuery
>;
export const openRouterModelsByProviderIdAndName = /* GraphQL */ `query OpenRouterModelsByProviderIdAndName(
  $providerId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenRouterModelFilterInput
  $limit: Int
  $nextToken: String
) {
  openRouterModelsByProviderIdAndName(
    providerId: $providerId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenRouterModelsByProviderIdAndNameQueryVariables,
  APITypes.OpenRouterModelsByProviderIdAndNameQuery
>;
export const openRouterModelsByCanonicalSlug = /* GraphQL */ `query OpenRouterModelsByCanonicalSlug(
  $canonicalSlug: String!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMOpenRouterModelFilterInput
  $limit: Int
  $nextToken: String
) {
  openRouterModelsByCanonicalSlug(
    canonicalSlug: $canonicalSlug
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OpenRouterModelsByCanonicalSlugQueryVariables,
  APITypes.OpenRouterModelsByCanonicalSlugQuery
>;
export const getLLMModelPricingSnapshot = /* GraphQL */ `query GetLLMModelPricingSnapshot($id: ID!) {
  getLLMModelPricingSnapshot(id: $id) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    source
    fetchedAt
    currency
    promptTokenUsdNano
    completionTokenUsdNano
    cacheReadTokenUsdNano
    cacheWriteTokenUsdNano
    reasoningTokenUsdNano
    webSearchUsdNano
    requestUsdNano
    imageUsdNano
    audioUsdNano
    internalNotes
    isCurrent
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMModelPricingSnapshotQueryVariables,
  APITypes.GetLLMModelPricingSnapshotQuery
>;
export const listLLMModelPricingSnapshots = /* GraphQL */ `query ListLLMModelPricingSnapshots(
  $filter: ModelLLMModelPricingSnapshotFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMModelPricingSnapshots(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      modelId
      model {
        id
        providerId
        provider {
          id
          displayName
          contactUrl
          description
          defaultIsModerated
          createdAt
          updatedAt
          __typename
        }
        canonicalSlug
        name
        description
        tokenizer
        instructType
        contextLength
        maxCompletionTokens
        isModerated
        architectureModality
        architectureInputModalities
        architectureOutputModalities
        supportedParameters
        defaultParameters
        huggingFaceId
        latestPricingSnapshotId
        isDeprecated
        deprecatedAt
        createdAt
        updatedAt
        __typename
      }
      source
      fetchedAt
      currency
      promptTokenUsdNano
      completionTokenUsdNano
      cacheReadTokenUsdNano
      cacheWriteTokenUsdNano
      reasoningTokenUsdNano
      webSearchUsdNano
      requestUsdNano
      imageUsdNano
      audioUsdNano
      internalNotes
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMModelPricingSnapshotsQueryVariables,
  APITypes.ListLLMModelPricingSnapshotsQuery
>;
export const pricingSnapshotsByModelIdAndFetchedAt = /* GraphQL */ `query PricingSnapshotsByModelIdAndFetchedAt(
  $modelId: ID!
  $fetchedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMModelPricingSnapshotFilterInput
  $limit: Int
  $nextToken: String
) {
  pricingSnapshotsByModelIdAndFetchedAt(
    modelId: $modelId
    fetchedAt: $fetchedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      modelId
      model {
        id
        providerId
        provider {
          id
          displayName
          contactUrl
          description
          defaultIsModerated
          createdAt
          updatedAt
          __typename
        }
        canonicalSlug
        name
        description
        tokenizer
        instructType
        contextLength
        maxCompletionTokens
        isModerated
        architectureModality
        architectureInputModalities
        architectureOutputModalities
        supportedParameters
        defaultParameters
        huggingFaceId
        latestPricingSnapshotId
        isDeprecated
        deprecatedAt
        createdAt
        updatedAt
        __typename
      }
      source
      fetchedAt
      currency
      promptTokenUsdNano
      completionTokenUsdNano
      cacheReadTokenUsdNano
      cacheWriteTokenUsdNano
      reasoningTokenUsdNano
      webSearchUsdNano
      requestUsdNano
      imageUsdNano
      audioUsdNano
      internalNotes
      isCurrent
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PricingSnapshotsByModelIdAndFetchedAtQueryVariables,
  APITypes.PricingSnapshotsByModelIdAndFetchedAtQuery
>;
export const getLLMModelCapability = /* GraphQL */ `query GetLLMModelCapability($id: ID!) {
  getLLMModelCapability(id: $id) {
    id
    modelId
    model {
      id
      providerId
      provider {
        id
        displayName
        contactUrl
        description
        defaultIsModerated
        createdAt
        updatedAt
        __typename
      }
      canonicalSlug
      name
      description
      tokenizer
      instructType
      contextLength
      maxCompletionTokens
      isModerated
      architectureModality
      architectureInputModalities
      architectureOutputModalities
      supportedParameters
      defaultParameters
      huggingFaceId
      latestPricingSnapshotId
      isDeprecated
      deprecatedAt
      createdAt
      updatedAt
      __typename
    }
    category
    value
    metadata
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMModelCapabilityQueryVariables,
  APITypes.GetLLMModelCapabilityQuery
>;
export const listLLMModelCapabilities = /* GraphQL */ `query ListLLMModelCapabilities(
  $filter: ModelLLMModelCapabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMModelCapabilities(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      modelId
      model {
        id
        providerId
        provider {
          id
          displayName
          contactUrl
          description
          defaultIsModerated
          createdAt
          updatedAt
          __typename
        }
        canonicalSlug
        name
        description
        tokenizer
        instructType
        contextLength
        maxCompletionTokens
        isModerated
        architectureModality
        architectureInputModalities
        architectureOutputModalities
        supportedParameters
        defaultParameters
        huggingFaceId
        latestPricingSnapshotId
        isDeprecated
        deprecatedAt
        createdAt
        updatedAt
        __typename
      }
      category
      value
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMModelCapabilitiesQueryVariables,
  APITypes.ListLLMModelCapabilitiesQuery
>;
export const capabilitiesByModelId = /* GraphQL */ `query CapabilitiesByModelId(
  $modelId: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMModelCapabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  capabilitiesByModelId(
    modelId: $modelId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      modelId
      model {
        id
        providerId
        provider {
          id
          displayName
          contactUrl
          description
          defaultIsModerated
          createdAt
          updatedAt
          __typename
        }
        canonicalSlug
        name
        description
        tokenizer
        instructType
        contextLength
        maxCompletionTokens
        isModerated
        architectureModality
        architectureInputModalities
        architectureOutputModalities
        supportedParameters
        defaultParameters
        huggingFaceId
        latestPricingSnapshotId
        isDeprecated
        deprecatedAt
        createdAt
        updatedAt
        __typename
      }
      category
      value
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CapabilitiesByModelIdQueryVariables,
  APITypes.CapabilitiesByModelIdQuery
>;
export const capabilitiesByCategoryAndValue = /* GraphQL */ `query CapabilitiesByCategoryAndValue(
  $modelId: ID!
  $value: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMModelCapabilityFilterInput
  $limit: Int
  $nextToken: String
) {
  capabilitiesByCategoryAndValue(
    modelId: $modelId
    value: $value
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      modelId
      model {
        id
        providerId
        provider {
          id
          displayName
          contactUrl
          description
          defaultIsModerated
          createdAt
          updatedAt
          __typename
        }
        canonicalSlug
        name
        description
        tokenizer
        instructType
        contextLength
        maxCompletionTokens
        isModerated
        architectureModality
        architectureInputModalities
        architectureOutputModalities
        supportedParameters
        defaultParameters
        huggingFaceId
        latestPricingSnapshotId
        isDeprecated
        deprecatedAt
        createdAt
        updatedAt
        __typename
      }
      category
      value
      metadata
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CapabilitiesByCategoryAndValueQueryVariables,
  APITypes.CapabilitiesByCategoryAndValueQuery
>;
export const getLLMScheduledPrompt = /* GraphQL */ `query GetLLMScheduledPrompt($id: ID!) {
  getLLMScheduledPrompt(id: $id) {
    id
    projectId
    status
    agentId
    agent {
      id
      status
      name
      description
      projectId
      systemInstructions
      systemInstructionsAction
      displayTheme
      cssUrl
      displayTitle
      displayStartMessageOrPrompt
      displayInitialMessageOrPrompt
      displayPromptTemplate
      displayFollowOnPrompts
      displayActions
      displayWidth
      displayHeight
      displayPlaceholder
      displayHideInitialPrompt
      displayShowSaveButton
      displayShowEmailButton
      displayShowCallToAction
      displayCallToActionButtonText
      displayCallToActionEmailAddress
      displayCallToActionEmailSubject
      displayCallToActionMustSendEmail
      displayScrollToEnd
      groupId
      data
      calls {
        items {
          id
          projectId
          status
          customerId
          serviceId
          modelId
          requestHash
          messages
          prompt
          response
          tokenCountPrompt
          tokenCountResponse
          createdAt
          hash
          country
          region
          city
          quality
          qualityComment
          apiKeyType
          toxicity
          randomGroup
          agentId
          conversationId
          timings
          customer_user_id
          customer_user_name
          customer_user_email
          batch
          callbackUrl
          batchId
          batchCustomId
          batchRequest
          executionMode
          pricingMode
          vendorBatchId
          vendorResponseId
          vendorStatus
          resolvedModelId
          usageTapCallId
          usageTapStripeCustomerId
          error
          cacheReadTokens
          cacheWriteTokens
          cacheStatus
          compactionTriggered
          compactionTokensSaved
          curatedTokensSaved
          curatedItems
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      documents {
        items {
          id
          projectId
          agentId
          status
          fileName
          fileSize
          fileType
          uploadDate
          uploader
          lastModifiedDate
          ownershipAttestation
          location
          type
          ragSplitter
          ragChunkSize
          ragChunkOverlap
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      mcpServers {
        items {
          id
          projectId
          agentId
          status
          approvalMode
          executionMode
          url
          accessToken
          headers
          stdioCommand
          stdioArgs
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ragQueryLimit
      ragRankLimit
      ragIncludeCitations
      ragDoRerank
      ragSkipChecksOnContext
      ragShadowRead
      visibility
      createConversationOnFirstChat
      customerEmailCaptureMode
      customerEmailCapturePlaceholder
      enableRAG
      enableMCP
      injectMemories
      injectKnowledgeGraph
      enableWebSearch
      linkedFileTypes
      thinkingDepth
      enablePromptCaching
      compactionPolicy
      compactionThreshold
      curateToolResults
      curateAfterTurns
      createdAt
      updatedAt
      __typename
    }
    title
    data
    prompt
    scheduledAt
    priorScheduledPromptId
    nextScheduledPromptId
    processedAt
    response
    failedTimes
    errorMessage
    notificationEmailAddresses
    notificationEmailSubject
    repeatIntervalHours
    followOnAgentId
    followOnFollowOnAgentId
    followOnTitle
    followOnPrompt
    followOnScheduledAtHours
    followOnNotificationEmailAddresses
    followOnNotificationEmailSubject
    followOnRepeatIntervalHours
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMScheduledPromptQueryVariables,
  APITypes.GetLLMScheduledPromptQuery
>;
export const listLLMScheduledPrompts = /* GraphQL */ `query ListLLMScheduledPrompts(
  $filter: ModelLLMScheduledPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMScheduledPrompts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMScheduledPromptsQueryVariables,
  APITypes.ListLLMScheduledPromptsQuery
>;
export const scheduledPromptsByProjectId = /* GraphQL */ `query ScheduledPromptsByProjectId(
  $projectId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMScheduledPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledPromptsByProjectId(
    projectId: $projectId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledPromptsByProjectIdQueryVariables,
  APITypes.ScheduledPromptsByProjectIdQuery
>;
export const scheduledPromptsByStatus = /* GraphQL */ `query ScheduledPromptsByStatus(
  $status: LLMScheduledPromptStatus!
  $scheduledAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMScheduledPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledPromptsByStatus(
    status: $status
    scheduledAt: $scheduledAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledPromptsByStatusQueryVariables,
  APITypes.ScheduledPromptsByStatusQuery
>;
export const scheduledPromptsByAgentId = /* GraphQL */ `query ScheduledPromptsByAgentId(
  $agentId: ID!
  $scheduledAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMScheduledPromptFilterInput
  $limit: Int
  $nextToken: String
) {
  scheduledPromptsByAgentId(
    agentId: $agentId
    scheduledAt: $scheduledAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ScheduledPromptsByAgentIdQueryVariables,
  APITypes.ScheduledPromptsByAgentIdQuery
>;
export const getLLMTrigger = /* GraphQL */ `query GetLLMTrigger($id: ID!) {
  getLLMTrigger(id: $id) {
    id
    projectId
    status
    triggerType
    scheduledPromptId
    scheduledPrompt {
      id
      projectId
      status
      agentId
      agent {
        id
        status
        name
        description
        projectId
        systemInstructions
        systemInstructionsAction
        displayTheme
        cssUrl
        displayTitle
        displayStartMessageOrPrompt
        displayInitialMessageOrPrompt
        displayPromptTemplate
        displayFollowOnPrompts
        displayActions
        displayWidth
        displayHeight
        displayPlaceholder
        displayHideInitialPrompt
        displayShowSaveButton
        displayShowEmailButton
        displayShowCallToAction
        displayCallToActionButtonText
        displayCallToActionEmailAddress
        displayCallToActionEmailSubject
        displayCallToActionMustSendEmail
        displayScrollToEnd
        groupId
        data
        calls {
          nextToken
          __typename
        }
        documents {
          nextToken
          __typename
        }
        mcpServers {
          nextToken
          __typename
        }
        ragQueryLimit
        ragRankLimit
        ragIncludeCitations
        ragDoRerank
        ragSkipChecksOnContext
        ragShadowRead
        visibility
        createConversationOnFirstChat
        customerEmailCaptureMode
        customerEmailCapturePlaceholder
        enableRAG
        enableMCP
        injectMemories
        injectKnowledgeGraph
        enableWebSearch
        linkedFileTypes
        thinkingDepth
        enablePromptCaching
        compactionPolicy
        compactionThreshold
        curateToolResults
        curateAfterTurns
        createdAt
        updatedAt
        __typename
      }
      title
      data
      prompt
      scheduledAt
      priorScheduledPromptId
      nextScheduledPromptId
      processedAt
      response
      failedTimes
      errorMessage
      notificationEmailAddresses
      notificationEmailSubject
      repeatIntervalHours
      followOnAgentId
      followOnFollowOnAgentId
      followOnTitle
      followOnPrompt
      followOnScheduledAtHours
      followOnNotificationEmailAddresses
      followOnNotificationEmailSubject
      followOnRepeatIntervalHours
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMTriggerQueryVariables,
  APITypes.GetLLMTriggerQuery
>;
export const listLLMTriggers = /* GraphQL */ `query ListLLMTriggers(
  $filter: ModelLLMTriggerFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMTriggers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      status
      triggerType
      scheduledPromptId
      scheduledPrompt {
        id
        projectId
        status
        agentId
        agent {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          displayTheme
          cssUrl
          displayTitle
          displayStartMessageOrPrompt
          displayInitialMessageOrPrompt
          displayPromptTemplate
          displayFollowOnPrompts
          displayActions
          displayWidth
          displayHeight
          displayPlaceholder
          displayHideInitialPrompt
          displayShowSaveButton
          displayShowEmailButton
          displayShowCallToAction
          displayCallToActionButtonText
          displayCallToActionEmailAddress
          displayCallToActionEmailSubject
          displayCallToActionMustSendEmail
          displayScrollToEnd
          groupId
          data
          ragQueryLimit
          ragRankLimit
          ragIncludeCitations
          ragDoRerank
          ragSkipChecksOnContext
          ragShadowRead
          visibility
          createConversationOnFirstChat
          customerEmailCaptureMode
          customerEmailCapturePlaceholder
          enableRAG
          enableMCP
          injectMemories
          injectKnowledgeGraph
          enableWebSearch
          linkedFileTypes
          thinkingDepth
          enablePromptCaching
          compactionPolicy
          compactionThreshold
          curateToolResults
          curateAfterTurns
          createdAt
          updatedAt
          __typename
        }
        title
        data
        prompt
        scheduledAt
        priorScheduledPromptId
        nextScheduledPromptId
        processedAt
        response
        failedTimes
        errorMessage
        notificationEmailAddresses
        notificationEmailSubject
        repeatIntervalHours
        followOnAgentId
        followOnFollowOnAgentId
        followOnTitle
        followOnPrompt
        followOnScheduledAtHours
        followOnNotificationEmailAddresses
        followOnNotificationEmailSubject
        followOnRepeatIntervalHours
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMTriggersQueryVariables,
  APITypes.ListLLMTriggersQuery
>;
export const triggersByProjectIdAndTriggerType = /* GraphQL */ `query TriggersByProjectIdAndTriggerType(
  $projectId: ID!
  $triggerType: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMTriggerFilterInput
  $limit: Int
  $nextToken: String
) {
  triggersByProjectIdAndTriggerType(
    projectId: $projectId
    triggerType: $triggerType
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      triggerType
      scheduledPromptId
      scheduledPrompt {
        id
        projectId
        status
        agentId
        agent {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          displayTheme
          cssUrl
          displayTitle
          displayStartMessageOrPrompt
          displayInitialMessageOrPrompt
          displayPromptTemplate
          displayFollowOnPrompts
          displayActions
          displayWidth
          displayHeight
          displayPlaceholder
          displayHideInitialPrompt
          displayShowSaveButton
          displayShowEmailButton
          displayShowCallToAction
          displayCallToActionButtonText
          displayCallToActionEmailAddress
          displayCallToActionEmailSubject
          displayCallToActionMustSendEmail
          displayScrollToEnd
          groupId
          data
          ragQueryLimit
          ragRankLimit
          ragIncludeCitations
          ragDoRerank
          ragSkipChecksOnContext
          ragShadowRead
          visibility
          createConversationOnFirstChat
          customerEmailCaptureMode
          customerEmailCapturePlaceholder
          enableRAG
          enableMCP
          injectMemories
          injectKnowledgeGraph
          enableWebSearch
          linkedFileTypes
          thinkingDepth
          enablePromptCaching
          compactionPolicy
          compactionThreshold
          curateToolResults
          curateAfterTurns
          createdAt
          updatedAt
          __typename
        }
        title
        data
        prompt
        scheduledAt
        priorScheduledPromptId
        nextScheduledPromptId
        processedAt
        response
        failedTimes
        errorMessage
        notificationEmailAddresses
        notificationEmailSubject
        repeatIntervalHours
        followOnAgentId
        followOnFollowOnAgentId
        followOnTitle
        followOnPrompt
        followOnScheduledAtHours
        followOnNotificationEmailAddresses
        followOnNotificationEmailSubject
        followOnRepeatIntervalHours
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TriggersByProjectIdAndTriggerTypeQueryVariables,
  APITypes.TriggersByProjectIdAndTriggerTypeQuery
>;
export const triggersByStatus = /* GraphQL */ `query TriggersByStatus(
  $status: LLMTriggerStatus!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMTriggerFilterInput
  $limit: Int
  $nextToken: String
) {
  triggersByStatus(
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      triggerType
      scheduledPromptId
      scheduledPrompt {
        id
        projectId
        status
        agentId
        agent {
          id
          status
          name
          description
          projectId
          systemInstructions
          systemInstructionsAction
          displayTheme
          cssUrl
          displayTitle
          displayStartMessageOrPrompt
          displayInitialMessageOrPrompt
          displayPromptTemplate
          displayFollowOnPrompts
          displayActions
          displayWidth
          displayHeight
          displayPlaceholder
          displayHideInitialPrompt
          displayShowSaveButton
          displayShowEmailButton
          displayShowCallToAction
          displayCallToActionButtonText
          displayCallToActionEmailAddress
          displayCallToActionEmailSubject
          displayCallToActionMustSendEmail
          displayScrollToEnd
          groupId
          data
          ragQueryLimit
          ragRankLimit
          ragIncludeCitations
          ragDoRerank
          ragSkipChecksOnContext
          ragShadowRead
          visibility
          createConversationOnFirstChat
          customerEmailCaptureMode
          customerEmailCapturePlaceholder
          enableRAG
          enableMCP
          injectMemories
          injectKnowledgeGraph
          enableWebSearch
          linkedFileTypes
          thinkingDepth
          enablePromptCaching
          compactionPolicy
          compactionThreshold
          curateToolResults
          curateAfterTurns
          createdAt
          updatedAt
          __typename
        }
        title
        data
        prompt
        scheduledAt
        priorScheduledPromptId
        nextScheduledPromptId
        processedAt
        response
        failedTimes
        errorMessage
        notificationEmailAddresses
        notificationEmailSubject
        repeatIntervalHours
        followOnAgentId
        followOnFollowOnAgentId
        followOnTitle
        followOnPrompt
        followOnScheduledAtHours
        followOnNotificationEmailAddresses
        followOnNotificationEmailSubject
        followOnRepeatIntervalHours
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TriggersByStatusQueryVariables,
  APITypes.TriggersByStatusQuery
>;
export const getLLMMemory = /* GraphQL */ `query GetLLMMemory($id: ID!) {
  getLLMMemory(id: $id) {
    id
    projectId
    status
    entityType
    customerId
    agentId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    key
    data
    tags
    memoryType
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMMemoryQueryVariables,
  APITypes.GetLLMMemoryQuery
>;
export const listLLMMemories = /* GraphQL */ `query ListLLMMemories(
  $filter: ModelLLMMemoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMMemories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      projectId
      status
      entityType
      customerId
      agentId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      key
      data
      tags
      memoryType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMMemoriesQueryVariables,
  APITypes.ListLLMMemoriesQuery
>;
export const memoryByProjectIdAndKey = /* GraphQL */ `query MemoryByProjectIdAndKey(
  $projectId: ID!
  $key: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMMemoryFilterInput
  $limit: Int
  $nextToken: String
) {
  memoryByProjectIdAndKey(
    projectId: $projectId
    key: $key
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      entityType
      customerId
      agentId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      key
      data
      tags
      memoryType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MemoryByProjectIdAndKeyQueryVariables,
  APITypes.MemoryByProjectIdAndKeyQuery
>;
export const memoryByStatus = /* GraphQL */ `query MemoryByStatus(
  $status: String!
  $sortDirection: ModelSortDirection
  $filter: ModelLLMMemoryFilterInput
  $limit: Int
  $nextToken: String
) {
  memoryByStatus(
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      entityType
      customerId
      agentId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      key
      data
      tags
      memoryType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MemoryByStatusQueryVariables,
  APITypes.MemoryByStatusQuery
>;
export const memoryByCustomerIdAndKey = /* GraphQL */ `query MemoryByCustomerIdAndKey(
  $customerId: ID!
  $key: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMMemoryFilterInput
  $limit: Int
  $nextToken: String
) {
  memoryByCustomerIdAndKey(
    customerId: $customerId
    key: $key
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      entityType
      customerId
      agentId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      key
      data
      tags
      memoryType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MemoryByCustomerIdAndKeyQueryVariables,
  APITypes.MemoryByCustomerIdAndKeyQuery
>;
export const memoryByAgentIdAndKey = /* GraphQL */ `query MemoryByAgentIdAndKey(
  $agentId: ID!
  $key: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMMemoryFilterInput
  $limit: Int
  $nextToken: String
) {
  memoryByAgentIdAndKey(
    agentId: $agentId
    key: $key
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      status
      entityType
      customerId
      agentId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      key
      data
      tags
      memoryType
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MemoryByAgentIdAndKeyQueryVariables,
  APITypes.MemoryByAgentIdAndKeyQuery
>;
export const getLLMKnowledgeGraph = /* GraphQL */ `query GetLLMKnowledgeGraph($id: ID!) {
  getLLMKnowledgeGraph(id: $id) {
    id
    projectId
    customerId
    customer {
      id
      name
      status
      tokensRemaining
      lastCallMadeAt
      numberOfCallsMade
      projectId
      loadSheddingTier
      dataResidency
      createdAt
      enterpriseUser
      tokenReplenishmentAmount
      tokenReplenishmentPeriod
      lastReplenishedAt
      nextReplenishAt
      usageTierId
      usageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierId
      nextUsageTier {
        id
        projectId
        status
        name
        description
        version
        activeAt
        inactiveAt
        priorUsageTierId
        priorUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        baseUsageTierId
        baseUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        replenishmentPeriod
        replenishmentMethod
        usageLimitAction
        standardTokenReplenishmentAmount
        premiumTokenReplenishmentAmount
        superPremiumTokenReplenishmentAmount
        reasoningTokenReplenishmentAmount
        standardCallReplenishmentAmount
        premiumCallReplenishmentAmount
        superPremiumCallReplenishmentAmount
        reasoningCallReplenishmentAmount
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        createdAt
        updatedAt
        __typename
      }
      nextUsageTierAt
      usageLimitAction
      standardTokensRemaining
      premiumTokensRemaining
      superPremiumTokensRemaining
      reasoningTokensRemaining
      standardCallsRemaining
      premiumCallsRemaining
      superPremiumCallsRemaining
      reasoningCallsRemaining
      standardTokenUnlimited
      premiumTokenUnlimited
      superPremiumTokenUnlimited
      reasoningTokenUnlimited
      standardCallUnlimited
      premiumCallUnlimited
      superPremiumCallUnlimited
      reasoningCallUnlimited
      updatedAt
      __typename
    }
    status
    version
    title
    description
    graphData
    memoryCount
    generatedFromMemoryIds
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMKnowledgeGraphQueryVariables,
  APITypes.GetLLMKnowledgeGraphQuery
>;
export const listLLMKnowledgeGraphs = /* GraphQL */ `query ListLLMKnowledgeGraphs(
  $filter: ModelLLMKnowledgeGraphFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMKnowledgeGraphs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      status
      version
      title
      description
      graphData
      memoryCount
      generatedFromMemoryIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMKnowledgeGraphsQueryVariables,
  APITypes.ListLLMKnowledgeGraphsQuery
>;
export const knowledgeGraphsByProjectId = /* GraphQL */ `query KnowledgeGraphsByProjectId(
  $projectId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMKnowledgeGraphFilterInput
  $limit: Int
  $nextToken: String
) {
  knowledgeGraphsByProjectId(
    projectId: $projectId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      status
      version
      title
      description
      graphData
      memoryCount
      generatedFromMemoryIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KnowledgeGraphsByProjectIdQueryVariables,
  APITypes.KnowledgeGraphsByProjectIdQuery
>;
export const knowledgeGraphsByCustomerIdAndCreatedAt = /* GraphQL */ `query KnowledgeGraphsByCustomerIdAndCreatedAt(
  $customerId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMKnowledgeGraphFilterInput
  $limit: Int
  $nextToken: String
) {
  knowledgeGraphsByCustomerIdAndCreatedAt(
    customerId: $customerId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      customerId
      customer {
        id
        name
        status
        tokensRemaining
        lastCallMadeAt
        numberOfCallsMade
        projectId
        loadSheddingTier
        dataResidency
        createdAt
        enterpriseUser
        tokenReplenishmentAmount
        tokenReplenishmentPeriod
        lastReplenishedAt
        nextReplenishAt
        usageTierId
        usageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierId
        nextUsageTier {
          id
          projectId
          status
          name
          description
          version
          activeAt
          inactiveAt
          priorUsageTierId
          baseUsageTierId
          replenishmentPeriod
          replenishmentMethod
          usageLimitAction
          standardTokenReplenishmentAmount
          premiumTokenReplenishmentAmount
          superPremiumTokenReplenishmentAmount
          reasoningTokenReplenishmentAmount
          standardCallReplenishmentAmount
          premiumCallReplenishmentAmount
          superPremiumCallReplenishmentAmount
          reasoningCallReplenishmentAmount
          standardTokenUnlimited
          premiumTokenUnlimited
          superPremiumTokenUnlimited
          reasoningTokenUnlimited
          standardCallUnlimited
          premiumCallUnlimited
          superPremiumCallUnlimited
          reasoningCallUnlimited
          createdAt
          updatedAt
          __typename
        }
        nextUsageTierAt
        usageLimitAction
        standardTokensRemaining
        premiumTokensRemaining
        superPremiumTokensRemaining
        reasoningTokensRemaining
        standardCallsRemaining
        premiumCallsRemaining
        superPremiumCallsRemaining
        reasoningCallsRemaining
        standardTokenUnlimited
        premiumTokenUnlimited
        superPremiumTokenUnlimited
        reasoningTokenUnlimited
        standardCallUnlimited
        premiumCallUnlimited
        superPremiumCallUnlimited
        reasoningCallUnlimited
        updatedAt
        __typename
      }
      status
      version
      title
      description
      graphData
      memoryCount
      generatedFromMemoryIds
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.KnowledgeGraphsByCustomerIdAndCreatedAtQueryVariables,
  APITypes.KnowledgeGraphsByCustomerIdAndCreatedAtQuery
>;
export const getLLMAgentValidation = /* GraphQL */ `query GetLLMAgentValidation($id: ID!) {
  getLLMAgentValidation(id: $id) {
    id
    projectId
    agentId
    name
    description
    operator
    expectedValue
    customPromptTemplate
    status
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLLMAgentValidationQueryVariables,
  APITypes.GetLLMAgentValidationQuery
>;
export const listLLMAgentValidations = /* GraphQL */ `query ListLLMAgentValidations(
  $filter: ModelLLMAgentValidationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLLMAgentValidations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      name
      description
      operator
      expectedValue
      customPromptTemplate
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLLMAgentValidationsQueryVariables,
  APITypes.ListLLMAgentValidationsQuery
>;
export const validationsByAgentId = /* GraphQL */ `query ValidationsByAgentId(
  $agentId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLLMAgentValidationFilterInput
  $limit: Int
  $nextToken: String
) {
  validationsByAgentId(
    agentId: $agentId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      projectId
      agentId
      name
      description
      operator
      expectedValue
      customPromptTemplate
      status
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ValidationsByAgentIdQueryVariables,
  APITypes.ValidationsByAgentIdQuery
>;
